var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessArea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "business-area") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "budicon-business-area"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5,23H24V10a1,1,0,0,0-1-1H22V8.5a.5.5,0,0,0-1,0V9H20a1,1,0,0,0-1,1V23H17V4a1,1,0,0,0-1-1H13V.5a.5.5,0,0,0-1,0V3H9A1,1,0,0,0,8,4V23H6V10A1,1,0,0,0,5,9H4V8.453A.452.452,0,0,0,3.548,8h-.1A.452.452,0,0,0,3,8.453V9H2a1,1,0,0,0-1,1V23H.5a.5.5,0,0,0,0,1h24a.5.5,0,0,0,0-1ZM2,23V10H5V23Zm7,0V4h7V23Zm11,0V10h3V23Z",
    style: {
      fill: "#353638"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,6h-4a.5.5,0,0,0,0,1h4a.5.5,0,0,0,0-1Z",
    style: {
      fill: "#353638"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,9h-4a.5.5,0,1,0,0,1h4a.5.5,0,1,0,0-1Z",
    style: {
      fill: "#353638"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,12h-4a.5.5,0,0,0,0,1h4a.5.5,0,0,0,0-1Z",
    style: {
      fill: "#353638"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,15h-4a.5.5,0,0,0,0,1h4a.5.5,0,0,0,0-1Z",
    style: {
      fill: "#353638"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,18h-4a.5.5,0,0,0,0,1h4a.5.5,0,0,0,0-1Z",
    style: {
      fill: "#353638"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 11,
    width: 1,
    height: 1,
    style: {
      fill: "#353638"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 14,
    width: 1,
    height: 1,
    style: {
      fill: "#353638"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 17,
    width: 1,
    height: 1,
    style: {
      fill: "#353638"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 20,
    width: 1,
    height: 1,
    style: {
      fill: "#353638"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 1,
    height: 1,
    style: {
      fill: "#353638"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 1,
    height: 1,
    style: {
      fill: "#353638"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17,
    width: 1,
    height: 1,
    style: {
      fill: "#353638"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 20,
    width: 1,
    height: 1,
    style: {
      fill: "#353638"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessArea);
export default __webpack_public_path__ + "static/media/business-area.98d8530e8ba83b1a86caa7e0a0c546f7.svg";
export { ForwardRef as ReactComponent };